import ApiService from './api-services';

const titleGenerationService = new ApiService('/title-generation');

interface GenerateTitlePayload {
  session_id: string;
  title?: string; // Optional for automatic generation, required for manual update
  user_query?: string; // Optional user query for better title generation
}

export interface TitleResponse {
  title: string;
}

export const generateTitle = (data: GenerateTitlePayload) => {
  return titleGenerationService.postData('', data);
};

export const updateTitle = (data: GenerateTitlePayload) => {
  if (!data.title) {
    throw new Error('Title is required for an update.');
  }
  return titleGenerationService.postData('/update', data);
};
